import axios from 'axios'
import store from '../store'
const serverIp = 'campus.liveabc.com'
const appPath = '/LiveCampus/api'
// const serverIp = 'educloud.liveabc.com'
// const appPath = '/CampusLearning/api'
export const apiPath = 'https://' + serverIp + appPath

let websocket = {}

const api = axios.create({
  baseURL: apiPath,
  timeout: 60000
})

api.interceptors.request.use(function (config) {
  config.headers.Authorization = 'Bearer ' + store.state.auth.user.access_token
  if (!(config.method === 'post' && (config.url.indexOf('/Attacheds') > -1 || config.url.indexOf('/Record/add') > -1 || config.url.indexOf('/Record/update') > -1))) {
    if (config.url === apiPath + '/TravelTaiwan/LearningPoint') {
      store.commit('isLoading', false)
    } else {
      store.commit('isLoading', true)
    }
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

api.interceptors.response.use(function (response) {
  store.commit('isLoading', false)
  return response
}, async function (error) {
  store.commit('isLoading', false)
  if (error.response && error.response.status === 401) {
    // await store.dispatch('logout')
    // window.location.href = window.location.origin + '/user/logout'
    store.commit('setErrorMessage', 'already_logout')
  } else if (error.response.data) {
    store.commit('setErrorMessage', error.response.data.Message)
  } else {
    store.commit('setErrorMessage', error.message)
  }
  return Promise.reject(error)
})

export const Socket = {
  init: () => {
    let token = window.localStorage.getItem('token')
    websocket = new window.WebSocket('wss://' + serverIp + appPath + '/ws?platform=Web&token=' + token)
    websocket.onopen = () => {
      console.log('socket connected')
    }

    websocket.onmessage = (evt) => {
      console.log('RESPONSE: ' + evt.data)
    }

    websocket.onerror = (evt) => {
      console.log('ERROR: ' + evt.data)
    }
  },

  sendMessage: (message) => {
    if (websocket.readyState !== websocket.OPEN) {
      console.log('socket has not connected')
      window.setTimeout(() => {
        try {
          websocket.send(message)
        } catch (e) {
          console.log(e)
        }
      }, 3000)
    } else {
      try {
        websocket.send(message)
      } catch (e) {
        console.log(e)
      }
    }
  },

  close: () => {
    if (websocket.readyState === websocket.OPEN) {
      websocket.close()
      console.log('socket is closed')
    } else {
      console.log('socket is not open')
    }
  }
}

export default api



// WEBPACK FOOTER //
// ./src/store/api.js